export interface DevicesFront {
  device_id: string;
  is_vpn: boolean;
  user_agent: string;
  platform: string;
  device_type: "desktop" | "mobile" | "tablet";
  browser_name: string;
  browser_version: string;
  language: string;
  timezone_offset: number;
  screen_resolution: string;
  is_headless: boolean;
  incognito: boolean;
}

export interface DeviceRequest {
  data: string;
}

export interface DeviceResponse {
  is_logout: boolean;
}

export const S_D_K = "8f7d3b2a1c9e6f4a5b8c2d7e1f3a9b6c";
